import { render, staticRenderFns } from "./BGG.vue?vue&type=template&id=127ca4e6&scoped=true"
import script from "./BGG.vue?vue&type=script&lang=js"
export * from "./BGG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127ca4e6",
  null
  
)

export default component.exports